export default __webpack_public_path__ + "static/media/calculator-moneystack7.0c8581f0.png";